const KEY = 'returnPath'

// Where to go once logged in. It lives in sessionStorage so it
// survives the round trip through Google in the same tab.
export function rememberReturnPath(path) {
  if (['/', '/login', '/welcome'].includes(path))
    return
  try {
    sessionStorage.setItem(KEY, path)
  } catch {
    return
  }
}

export function peekReturnPath() {
  try {
    const path = sessionStorage.getItem(KEY)
    if (path && path.startsWith('/') && !path.startsWith('//'))
      return path
  } catch {
    return null
  }

  return null
}

export function takeReturnPath() {
  const path = peekReturnPath()
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    return path
  }

  return path
}
